import { formatDateToIsoString } from "@/helpers/helpers";

export default {
  requestQueryParams() {
    const params = new URLSearchParams();

    if (this.filters.keyword !== "" && this.filters.keyword !== null) {
      params.set("keyword", this.filters.keyword);
    }

    if (
      this.filters.advanced.regDates != null &&
      this.filters.advanced.regDates.length > 0
    ) {
      const regStartDate = this.filters.advanced.regDates[0];
      const regEndDate = this.filters.advanced.regDates.at(-1);
      params.set("regStartDate", formatDateToIsoString(new Date(regStartDate)));
      params.set("regEndDate", formatDateToIsoString(new Date(regEndDate)));
    }

    if (this.filters.advanced.roles?.length > 0) {
      this.filters.advanced.roles.forEach((element) =>
        params.append("roles", element)
      );
    }

    if (this.filters.advanced.userResponsibilities?.length > 0) {
      this.filters.advanced.userResponsibilities.forEach((element) =>
        params.append("userResponsibilities", element)
      );
    }

    return params;
  },
  getEditingUser() {
    return this.editingUser;
  },
};
